const PUBLIC_ROUTE_NAMES = new Set([
  "login",
  "verify",
  "securePaymentLink",
  "assistedLoanHandoff",
  "home",
  "store",
  "storeList",
  "storeListAll",
  "storeGroup",
  "storeDetail",
  "imageGallery",
  "faq",
  "rules",
  "contact",
  "validationGuide",
]);

function isPublicRouteName(routeName) {
  return PUBLIC_ROUTE_NAMES.has(routeName);
}

function getSafeRedirect(value) {
  const redirect = Array.isArray(value) ? value[0] : value;
  if (typeof redirect !== "string" || !redirect.startsWith("/") || redirect.startsWith("//")) {
    return null;
  }

  if (redirect === "/login" || redirect.startsWith("/login?") || redirect === "/verify" || redirect.startsWith("/verify?")) {
    return null;
  }

  return redirect;
}

module.exports = {
  PUBLIC_ROUTE_NAMES,
  getSafeRedirect,
  isPublicRouteName,
};
